var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecurso4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 147.67 147.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:gray;stroke-miterlimit:10;stroke-width:6.01px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_123",
    "data-name": "Grupo 123"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_126",
    "data-name": "Elipse 126",
    className: "cls-1",
    cx: 71.53,
    cy: 77.26,
    r: 59.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_456",
    "data-name": "Trazado 456",
    className: "cls-1",
    d: "M71.53,17.4s-83.17,55.43-2.35,119.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_457",
    "data-name": "Trazado 457",
    className: "cls-1",
    d: "M11.67,77.47c23.9,26.77,64,68.37,119.73-.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_458",
    "data-name": "Trazado 458",
    className: "cls-1",
    d: "M11.67,77.26C69.39.72,120.05,64,131.4,77.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_459",
    "data-name": "Trazado 459",
    className: "cls-1",
    d: "M71.53,17.4s83,53.42-.54,119.35"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_127",
    "data-name": "Elipse 127",
    className: "cls-1",
    cx: 71.53,
    cy: 16.27,
    r: 13.27
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_129",
    "data-name": "Elipse 129",
    className: "cls-1",
    cx: 131.4,
    cy: 77.47,
    r: 13.27
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_128",
    "data-name": "Elipse 128",
    className: "cls-1",
    cx: 71.08,
    cy: 131.8,
    r: 12.47
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_130",
    "data-name": "Elipse 130",
    className: "cls-1",
    cx: 16.27,
    cy: 77.47,
    r: 13.27
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurso4);
export default __webpack_public_path__ + "static/media/Recurso 4.52670f9aed8e8df5cacb777e02edc05d.svg";
export { ForwardRef as ReactComponent };